import React, { useMemo } from 'react';


// import img1 from '../assets/suits/blezer.jpg'
// import img2 from '../assets/suits/jodhpuri.jpg'
// import img3 from '../assets/suits/kurta.jpg'
// import img4 from '../assets/suits/pant.jpg'
// import img5 from '../assets/suits/pant_shirt.jpg'
// import img6 from '../assets/suits/sherwani.jpg'
// import img7 from '../assets/suits/shirt.jpg'
// import img8 from '../assets/suits/suit.jpg'
// import img9 from '../assets/suits/uniform.jpg'
// import img10 from '../assets/suits/vest_coat.jpg'

import Hero from './Home/hero';
import FadeInSection from './FadeInSection';

import suit from '../assets/samples/Types/CUSTOM SUIT.jpg'
import shirt_pant from '../assets/samples/Types/CUSTOM FORMAL.jpg'
import blazer from '../assets/samples/Types/CUSTOM BLAZER.jpg'
import kurta from '../assets/samples/Types/CUSTOM KURTA.jpg'
import uniform from '../assets/samples/Types/CUSTOM UNIFORM.jpg'
import shirt from '../assets/samples/Types/CUSTOM SHIRT.jpg'
import pant from '../assets/samples/Types/CUSTOM PANT.jpg'
import sherwani from '../assets/samples/Types/CUSTOM SHERWANI.jpg'
import jubba from '../assets/samples/Types/CUSTOM JUBBA.jpg'
import tshirt from '../assets/samples/Types/CUSTOM T SHIRT.jpg'
import jackets from '../assets/samples/Types/CUSTOM SADRI.jpg'
import longCoat from '../assets/samples/Types/CUSTOM LONG COAT.jpg'




// const Gallery = React.lazy(()=>import('./Last/gallery'))
const Explore = React.lazy(()=>import('./Explore/explore'))
// const Presets = React.lazy(()=>import('./Middle/Presets'))
const Feel = React.lazy(()=>import('./Explore/feel'))
const Reviews_Colabs = React.lazy(()=>import('./Last/reviews'))
const Process = React.lazy(()=>import('./Middle/process'))
const TailoredLook = React.lazy(()=>import('./Home/TailoredLook'))
const SeasonalCollection = React.lazy(()=>import('./Home/SeasonalCollection'))
const CraftsmanshipSection = React.lazy(()=>import('./CraftsmanshipSection'))

export default function HomePage(){

    // const gallery = useMemo(
    //     () => [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10],
    //     []
    //   );
    const images = [ suit,
        shirt_pant,
        blazer,
        kurta,
        uniform,
        shirt,
        pant,
        sherwani,
        jubba,
        tshirt,
        jackets,
        longCoat  ]
    function scrollToElement(id) {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }
    

    return(
    <div className="HomePage">
        
        <React.Suspense>
        <Hero scrollToElement={scrollToElement} />
        <React.Suspense>
            <Explore {...{"images":images}}/>
        </React.Suspense>
        <React.Suspense>
            <Process/>
        </React.Suspense>
        <React.Suspense>
            <TailoredLook/>
        </React.Suspense>
        <React.Suspense>
            <FadeInSection>
                <SeasonalCollection/>
            </FadeInSection>
        </React.Suspense>

        <React.Suspense>
            <FadeInSection>
                <CraftsmanshipSection/>
            </FadeInSection>
        </React.Suspense>

        {/* <React.Suspense>
            <Feel/>
        </React.Suspense> */}
        <React.Suspense>
            <Reviews_Colabs/>
        </React.Suspense>
        {/* <React.Suspense>
            <Gallery {...{"images":gallery}}/>
        </React.Suspense> */}
            </React.Suspense>       
    </div>
    )
}
